'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002414 from "./presto.-Presto$$anon$14.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$13() {
  this.bb4 = null;
  this.baW = null;
  this.baX = false;
  this.bb5 = null;
  this.bb6 = false;
  this.bb9 = null;
  this.bb2 = null;
  this.bb3 = false;
  this.baY = null;
  this.baZ = false;
  this.bb0 = null;
  this.bb1 = false;
  this.bb7 = false;
  this.bb8 = false;
  this.bb4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bb9 = "MorbidUserDetails";
}
export { $c_Lpresto_Presto$$anon$13 as $c_Lpresto_Presto$$anon$13 };
$p = $c_Lpresto_Presto$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$13;
/** @constructor */
function $h_Lpresto_Presto$$anon$13() {
}
export { $h_Lpresto_Presto$$anon$13 as $h_Lpresto_Presto$$anon$13 };
$h_Lpresto_Presto$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bb4;
});
$p.L = (function() {
  if ((!this.baX)) {
    this.baW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.baX = true;
  }
  return this.baW;
});
$p.O = (function() {
  if ((!this.bb6)) {
    this.bb5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bb6 = true;
  }
  return this.bb5;
});
$p.E = (function() {
  return this.bb9;
});
$p.t = (function() {
  if ((!this.bb3)) {
    this.bb2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bb3 = true;
  }
  return this.bb2;
});
$p.M = (function() {
  if ((!this.baZ)) {
    this.baY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.baZ = true;
  }
  return this.baY;
});
$p.Q = (function() {
  if ((!this.bb1)) {
    this.bb0 = new $j_presto$002e$002dPresto$0024$0024anon$002414.$c_Lpresto_Presto$$anon$14();
    this.bb1 = true;
  }
  return this.bb0;
});
$p.w = (function() {
  if ((!this.bb8)) {
    this.bb7 = false;
    this.bb8 = true;
  }
  return this.bb7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee91) => ((p) => \u03b4scrutinee91.GD(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_Presto$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$13, "presto.Presto$$anon$13", ({
  N9: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$13 as $d_Lpresto_Presto$$anon$13 };
//# sourceMappingURL=presto.-Presto$$anon$13.js.map
